import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15,17 L19,17 C19,15.5 18,15 18,15 L18,6 C18,6 19,5.5 19,4.5 C19,3.5 18,3 17,3 C16,3 15,3.5 15,4.5 C15,5.5 16,6 16,6 L16,15 C16,15 15,15.5 15,17 Z"
});

var SvgQueues = function SvgQueues(props) {
  return _ref;
};

export default SvgQueues;